import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Fuel } from "lucide-react";

export default function DonationsCard() {
  const [donations, setDonations] = useState([]);

  useEffect(() => {
    api.get("/fuel/wall?limit=200").then((r) => setDonations(r.data || []));
  }, []);

  return (
    <div className="tac-card p-7 mt-8" data-testid="admin-donations-card">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <div className="overline flex items-center gap-2">
            <Fuel size={12} /> Fuel the journey
          </div>
          <h2 className="font-display text-3xl uppercase mt-2">Donations</h2>
        </div>
        <div className="font-mono-tactical text-xs text-white/50 uppercase tracking-[0.25em]">
          {donations.length} entries · ${donations.reduce((s, d) => s + d.amount, 0).toLocaleString()}
        </div>
      </div>
      <div className="mt-6 max-h-[420px] overflow-y-auto divide-y divide-white/5">
        {donations.length === 0 && (
          <div className="py-8 text-white/60 text-sm">No donations yet.</div>
        )}
        {donations.map((d) => (
          <div key={d.id} className="py-3 grid md:grid-cols-12 gap-3" data-testid={`donation-${d.id}`}>
            <div className="md:col-span-2 font-display text-2xl text-[#FFC107]">${d.amount.toFixed(0)}</div>
            <div className="md:col-span-3 font-semibold">{d.display_name || "Anonymous"}</div>
            <div className="md:col-span-5 text-sm text-white/75 italic">{d.message ? `"${d.message}"` : ""}</div>
            <div className="md:col-span-2 font-mono-tactical text-[10px] uppercase tracking-[0.2em] text-white/40">
              {new Date(d.created_at).toLocaleDateString()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
